import React from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "./HeroSection";
import Header from "./Header";
import FeaturesSection from "./FeaturesSection";
import AnalyticsSection from "./AnalyticsSection";
import WaitlistSection from "./WaitlistSection";
import Footer from "./Footer";

const TimeTrackerPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Kyros Time Tracker — Employee Tracking Made Easy | Join Waitlist</title>
        <meta
          name="description"
          content="Kyros Time Tracker makes employee tracking easy with desktop app and web portal. Get high-end analytics for better decisions. Join waitlist for 1 month free trial!"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://kyros.com/kyros-time-tracker" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "Kyros Time Tracker",
            description:
              "Employee tracking made easy with desktop app and web portal for admins and employees",
            applicationCategory: "BusinessApplication",
            operatingSystem: "Windows, macOS, Linux",
            offers: {
              "@type": "Offer",
              price: "0",
              priceCurrency: "USD",
              description: "Free trial available",
            },
            author: {
              "@type": "Organization",
              name: "Kyros",
            },
          })}
        </script>
      </Helmet>

      <div className="min-h-screen dark-gradient">
        <Header />
        <HeroSection />
        <FeaturesSection />
        <AnalyticsSection />
        <WaitlistSection />
        <Footer />
      </div>
    </>
  );
};

export default TimeTrackerPage;
